module.exports = __webpack_public_path__ + "img/hexagon.c1cb5842.svg";